import { useLassoTool } from '../../application/lassoToolStore';
import { useFilterStore } from '../../../public-filters/application/filterStore';

export function useLassoManager() {
  const { selection, clear, draw, toggle } = useLassoTool();
  const { setPolygonFeatures } = useFilterStore();

  const confirmLasso = () => {
    if (!selection.length) return;

    // something wrong here where if we add multiple sections, it only adds the last one
    setPolygonFeatures(prev => {
      const all = [ ...prev, ...selection ];

      const deduped = all.reduce((acc, feature) => {
        if (!acc.some(f => f.id === feature.id)) acc.push(feature);
        return acc;
      }, []);

      return deduped;
    });
    draw?.deleteAll();
    toggle();
  };

  const cancelLasso = () => {
    clear();
    draw?.deleteAll();
    draw?.changeMode('simple_select');
    setPolygonFeatures([]);
    toggle();
  };

  const clearSelection = () => {
    clear();
    draw?.deleteAll();
  };

  return {
    confirmLasso,
    cancelLasso,
    clearSelection,
    selection,
  };
}
